import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    // Landing page (marketing)
    { path: '', component: HomeComponent, title: 'Inicio' },

    // Transactional pages
    // Rooms catalog
    {
        path: 'habitaciones',
        title: 'Habitaciones',
        loadChildren: () => import('./features/rooms/rooms.routes')
    },

    // Store (artesanías) - now at /tienda
    {
        path: 'tienda',
        title: 'Tienda',
        loadChildren: () => import('./features/store/store.routes')
    },

    // Legacy redirect for /artesanias
    { path: 'artesanias', redirectTo: 'tienda', pathMatch: 'full' },
    { path: 'artesanias/:id', redirectTo: 'tienda/:id' },

    // Shopping cart
    {
        path: 'carrito',
        title: 'Carrito',
        loadComponent: () => import('./features/cart/cart.component').then(m => m.CartComponent)
    },

    // Booking wizard
    {
        path: 'reservar',
        title: 'Reservar',
        loadChildren: () => import('./features/booking/booking.routes')
    },

    // Auth routes
    {
        path: 'auth',
        loadChildren: () => import('./features/auth/auth.routes')
    },

    // Protected: User account
    {
        path: 'mi-cuenta',
        title: 'Mi Cuenta',
        loadChildren: () => import('./features/account/account.routes'),
        canActivate: [authGuard]
    },

    // Legal
    {
        path: 'politica-de-privacidad',
        title: 'Política de Privacidad',
        loadComponent: () => import('./features/legal/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
    },
    {
        path: 'terminos-y-condiciones',
        title: 'Términos y Condiciones',
        loadComponent: () => import('./features/legal/terms-conditions/terms-conditions.component').then(m => m.TermsConditionsComponent)
    },
    {
        path: 'libro-reclamaciones',
        title: 'Libro de Reclamaciones',
        loadComponent: () => import('./features/complaints/complaint-form.component').then(m => m.ComplaintFormComponent)
    },
    {
        path: 'libro-reclamaciones/confirmacion',
        title: 'Confirmación de Reclamo',
        loadComponent: () => import('./features/complaints/complaint-confirmation.component').then(m => m.ComplaintConfirmationComponent)
    },

    // Public Local Bookings
    {
        path: 'mis-reservas',
        title: 'Mis Reservas',
        loadComponent: () => import('./features/booking/local-bookings.component').then(m => m.LocalBookingsComponent)
    },

    // Payment confirmation
    {
        path: 'pago/confirmacion',
        title: 'Confirmación de Pago',
        loadComponent: () => import('./features/payment/payment-confirmation.component').then(m => m.PaymentConfirmationComponent)
    },

    // Fallback
    { path: '**', redirectTo: '' }
];
